import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, concatMap, map, Observable, ReplaySubject } from 'rxjs';
import { PasswordPolicy } from '../../../features/change-password/models/password-policy';
import { UserContext } from '../../models';
import { changePasswordUrl, passwordPolicyUrl } from '../constants';
import { UserContextService } from '../user-context.service';

@Injectable({ providedIn: 'root' })
export class PasswordService {
  private isPasswordSuccessSubject = new BehaviorSubject<boolean>(false);
  readonly isPasswordSuccess$ = this.isPasswordSuccessSubject.asObservable();

  private userContext$: ReplaySubject<UserContext>;

  constructor(private http: HttpClient, userContextService: UserContextService) {
    this.userContext$ = userContextService.userContext$;
  }

  showChangePasswordMessage(): void {
    return this.isPasswordSuccessSubject.next(true);
  }

  changePassword(password: string): Observable<boolean> {
    return this.http.post<boolean>(changePasswordUrl, { Password: password });
  }

  //
  // Obtains the password policy for the current user context's indicated program.
  getPolicy(): Observable<PasswordPolicy> {
    return this.userContext$.pipe(
      //The ReplaySubject gives us an Observable<UserContext>, so we need concatMap here to fish the value out
      concatMap(context => {
        return this.http.get(passwordPolicyUrl + '/' + context.programCode).pipe(
          map<any, PasswordPolicy>(response => {
            const policy = new PasswordPolicy();
            policy.hydrateFrom(response.policy);
            return policy;
          })
        );
      })
    );
  }
}
